import { useMemo } from 'react';
import { useSession } from 'components/Authenticated';
import { getSubdomainConfig, SUBDOMAIN_CONFIG } from 'libs/subdomain';
export const useAppSubdomain = (subpageName) => {
    var _a;
    const { session } = useSession();
    const hasApaClaim = session.login.hasClaim('dataTheme:apa');
    const config = useMemo(() => getSubdomainConfig(), []);
    const isSubdomain = useMemo(() => config !== undefined || hasApaClaim, [config, hasApaClaim]);
    const activeConfig = useMemo(() => {
        const firstConfig = SUBDOMAIN_CONFIG[Object.keys(SUBDOMAIN_CONFIG)[0]];
        return isSubdomain ? (config !== null && config !== void 0 ? config : firstConfig) : undefined;
    }, [config, isSubdomain]);
    const pageTitle = useMemo(() => {
        if ((activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.title) !== undefined) {
            return activeConfig.title;
        }
        return (subpageName !== undefined && subpageName !== '')
            ? `${subpageName} | Beey`
            : 'Beey';
    }, [activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.title, subpageName]);
    const subtitle = (_a = activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.subtitle) !== null && _a !== void 0 ? _a : '';
    return {
        isSubdomain,
        pageTitle,
        subtitle,
    };
};
